<template>
  <f7-sheet
    class="content-action-sheet padding-vertical-half"
    :opened="opened"
    close-by-outside-click
    @sheet:close="emitClose"
  >
    <div class="content-action-sheet__title text-align-center">
      {{ $t('common.whatDoYouWantToDoWith') }} <b>{{ field.name }}</b>
    </div>
    <div class="content-action-sheet__actions">
      <div class="text-align-center content-action-sheet__actions--delete">
        <img
          :src="deleteIcon"
          @click="deleteClicked"
        >
        <span>{{ $t('common.delete') }}</span>
      </div>
      <div class="text-align-center content-action-sheet__actions--edit">
        <img
          :src="editIcon"
          @click="editClicked"
        >
        <span>{{ $t('common.edit') }}</span>
      </div>
      <div class="text-align-center content-action-sheet__actions--edit">
        <img
          :src="createCropIcon"
          @click="createCropClicked"
        >
        <span>{{ $t('Cultivo', 1) }}</span>
      </div>
      <div class="text-align-center content-action-sheet__actions--edit">
        <img
          :src="createContractIcon"
          @click="createContractClicked"
        >
        <span>{{ $t('common.contract') }}</span>
      </div>
    </div>
  </f7-sheet>
</template>

<script>
import deleteIcon from '@/static/img/ic_button_delete.svg';
import editIcon from '@/static/img/ic_button_edit.svg';
import contractsIcon from '@/static/img/ic_button_contratos.svg';
import icCreateCrop from '@/static/img/ic_create_crop.svg';
import FieldService from '@/js/services/contracts/Fields';
import { ConfirmDialogGH } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';

export default {
  props: {
    opened: { type: Boolean, default: false },
    field: { type: Object, default: undefined },
  },

  emits: [
    'delete-field',
    'sheet:close',
  ],

  computed: {
    deleteIcon: () => deleteIcon,
    editIcon: () => editIcon,
    createContractIcon: () => contractsIcon,
    createCropIcon: () => icCreateCrop,
  },
  methods: {
    async deleteClicked() {
      this.emitClose();

      const res = await ConfirmDialogGH(this.$t('EliminarFinca'), this.$t('common.delete'));

      if (res) {
        await FieldService.deleteById(this.field.id);
        this.$emit('delete-field', this.field);
      }
    },
    editClicked() {
      this.emitClose();
      f7.views.main.router.navigate('/new-field/', {
        props: {
          farmerId: Number.parseInt(this.field.farmer, 10),
          fieldId: Number.parseInt(this.field.id, 10),
        },
      });

      // this.$emit('edit-field', this.field);
    },
    createContractClicked() {
      this.emitClose();
      f7.views.main.router.navigate('/new-contract/', {
        props: {
          fieldId: Number.parseInt(this.field.id, 10),
        },
      });
      // this.$emit('create-contract', this.field);
    },
    createCropClicked() {
      this.emitClose();
      f7.views.main.router.navigate('/new-crop/', {
        props: {
          fieldId: Number.parseInt(this.field.id, 10),
        },
      });
    },
    emitClose() {
      this.$emit('sheet:close');
    },
  },
};
</script>

<style scoped lang="scss">
.content-action-sheet {
  height: 20vh;
}

.col {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

span {
  display: block;
  color: var(--ha-blue);
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
}
</style>
